import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import AdminLogin from './pages/AdminLogin';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import ActivationCodes from './pages/ActivationCodes';
import MenuManagement from './pages/MenuManagement';
import FileViewer from './pages/FileViewer';
import FileUpload from './pages/FileUpload';
import AdminMonitor from './pages/AdminMonitor';
import ProtectedRoute from './components/ProtectedRoute';
import ProtectedLayout from './components/ProtectedLayout';
import './styles/dark-theme.css';
import './styles/responsive.css';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/gilAdmin" element={<AdminLogin />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <ProtectedLayout>
                <Dashboard />
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <ProtectedLayout>
                <Users />
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/activation-codes"
          element={
            <ProtectedRoute>
              <ProtectedLayout>
                <ActivationCodes />
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/menu-management"
          element={
            <ProtectedRoute>
              <ProtectedLayout>
                <MenuManagement />
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/file/:menuId"
          element={
            <ProtectedRoute>
              <ProtectedLayout>
                <FileViewer />
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/file-upload"
          element={
            <ProtectedRoute>
              <ProtectedLayout>
                <FileUpload />
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin-monitor"
          element={
            <ProtectedRoute>
              <ProtectedLayout>
                <AdminMonitor />
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
